/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { TsunamiSearchPage } from './events/search/TsunamiSearchPage';
import { RunupSearchPage } from './runups/search/RunupSearchPage';
import { DepositSearchPage } from './deposits/search/DepositSearchPage';
import { MarigramSearchPage } from './marigrams/search/MarigramSearchPage';
import { TsunamiContainer } from './events/data/TsunamiContainer';
import { RunupContainer } from './runups/data/RunupContainer';
import { DepositSearchResultsPage } from './deposits/data/DepositSearchResultsPage';
import { MarigramContainer } from './marigrams/data/MarigramContainer';
import { TsunamiEditPage } from './events/edit/TsunamiEditPage';
import { RunupEditPage } from './runups/edit/RunupEditPage';
import { DepositEditPage } from './deposits/edit/DepositEditPage';
import { MarigramEditPage } from './marigrams/edit/MarigramEditPage';
import { TsunamiInfoPage } from './events/info/TsunamiInfoPage';
import { RunupInfoPage } from './runups/info/RunupInfoPage';
import { MarigramInfoPage } from './marigrams/info/MarigramInfoPage';
import { TsunamiRelatedRunupPage } from './events/related-runup/TsunamiRelatedRunupPage';
import { DepositRelatedTsunamiPage } from './deposits/related-tsunamis/DepositRelatedTsunamiPage';
import { TsunamiRelatedDepositPage } from './events/related-deposit/TsunamiRelatedDepositPage';

import { withUser } from '../../../auth/withUser';
import { isDataManager } from '../../../../role/roleUtils';

const TsunamiUnwrapped = ({ basePath, authorities }) => {
  const dataManager = isDataManager(authorities);
  return (
    <Switch>
      <Route exact path={`${basePath}/event-search`} component={TsunamiSearchPage} />
      <Route exact path={`${basePath}/runup-search`} component={RunupSearchPage} />
      <Route exact path={`${basePath}/deposit-search`} component={DepositSearchPage} />
      <Route exact path={`${basePath}/marigram-search`} component={MarigramSearchPage} />
      <Route exact path={`${basePath}/event-data`} component={withUser(TsunamiContainer)} />
      <Route exact path={`${basePath}/runup-data`} component={withUser(RunupContainer)} />
      <Route exact path={`${basePath}/deposit-data`} component={DepositSearchResultsPage} />
      <Route exact path={`${basePath}/marigram-data`} component={withUser(MarigramContainer)} />
      { dataManager && <Route exact path={`${basePath}/update-tsunami/:id`} render={props => (<TsunamiEditPage key={props.match.params.id} {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/update-tsunami`} render={props => (<TsunamiEditPage {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/update-runup/:id`} render={props => (<RunupEditPage key={props.match.params.id} {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/update-runup`} render={props => (<RunupEditPage {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/update-deposit/:id`} render={props => (<DepositEditPage key={props.match.params.id} {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/update-deposit`} render={props => (<DepositEditPage {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/update-marigram/:id`} render={props => (<MarigramEditPage key={props.match.params.id} {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/update-marigram`} render={props => (<MarigramEditPage {...props} />)} />}
      <Route exact path={`${basePath}/event-more-info/:id`} component={withUser(TsunamiInfoPage)} />
      <Route exact path={`${basePath}/runup-more-info/:id`} component={withUser(RunupInfoPage)} />
      <Route exact path={`${basePath}/marigram-more-info/:id`} component={withUser(MarigramInfoPage)} />
      <Route exact path={`${basePath}/related-runups/:id`} component={TsunamiRelatedRunupPage} />
      <Route exact path={`${basePath}/deposit-events/:id`} component={DepositRelatedTsunamiPage} />
      <Route exact path={`${basePath}/related-deposits/:id`} component={TsunamiRelatedDepositPage} />
      <Redirect to={`${basePath}/event-search`} />
    </Switch>
  );
};

TsunamiUnwrapped.propTypes = {
  basePath: PropTypes.string.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};

export const Tsunami = withUser(TsunamiUnwrapped);
